import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from './baseQuery';

const tagTypes = [
  'Appointment',
  'Case',
  'Claim',
  'Customer',
  'DataExport',
  'DiagnosisCategory',
  'File',
  'Impersonation',
  'Lead',
  'LeadComment',
  'Location',
  'Message',
  'Patient',
  'Payer',
  'PayerPlan',
  'Provider',
  'Referrer',
  'ReferrerCompany',
  'Review',
  'Session',
  'SessionNote',
  'SessionType',
  'VacationTime',
];

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery(),
  tagTypes: tagTypes,
  endpoints: () => ({}),
});
